/**
 * Normalizes a URL by removing any trailing slashes from the base URL
 * and leading slashes from the endpoint.
 * @param {string} baseUrl - The base URL (e.g., API URL).
 * @param {string} endpoint - The endpoint to append to the base URL.
 * @returns {string} - The normalized URL.
 */
export const normalizeUrl = (baseUrl, endpoint) => {
    return `${baseUrl.replace(/\/+$/, "")}/${endpoint.replace(/^\/+/, "")}`;
  };